import GeoJsonGeometriesLookup from "geojson-geometries-lookup"
import feature_schema from "../configs/feature_schema.json"

const get_number_geojson_properties = (au_geo_data) => {
  if (au_geo_data) {
    const sample_properties = au_geo_data.features[0].properties
    let numeric_properties = []
    Object.keys(sample_properties).forEach((property) => {
      if (
        typeof sample_properties[property] == "number" &&
        Object.values(feature_schema.au).includes(property) === false &&
        !(
          property.slice(0, 2) === "s_" ||
          property.slice(0, 4) === "age_" ||
          property === "district_id"
        )
      ) {
        numeric_properties.push(property)
      }
    })
    return numeric_properties
  } else {
    return []
  }
}

const mapbox_to_geojson = (mapbox_feature) => {
  const feature = mapbox_feature.toJSON()
  const { id, properties, geometry } = feature
  return {
    id,
    properties,
    geometry,
  }
}

const capacity_from_details = (feature, fac_cap_property) => {
  const is_numeric = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n)
  }
  if (is_numeric(fac_cap_property)) {
    return fac_cap_property
  } else {
    return parseFloat(feature.properties[fac_cap_property])
  }
}

const spatial_merge = (facility_layer, au_layer) => {
  const glookup = new GeoJsonGeometriesLookup(au_layer)
  facility_layer.features = facility_layer.features.map((facility) => {
    const { coordinates } = facility.geometry
    const result = glookup.getContainers({
      type: "Point",
      coordinates: coordinates,
    })
    if (result.features.length > 0) {
      facility.properties[feature_schema.facility.au_id_property] =
        result.features[0].properties[feature_schema.au.id_property]
    }
    return facility
  })
  return facility_layer
}

const feature_from_id = (au_geo_json, au_id) => {
  const index = au_geo_json.features.findIndex((feature) => {
    // eslint-disable-next-line
    return feature.properties[feature_schema.au.id_property] == au_id
  })
  return au_geo_json.features[index]
}

const unique_fac_types = (layer) => {
  if (!layer) {
    return []
  }

  return [
    ...new Set(
      layer.features.map((feature) => {
        return feature.properties[feature_schema.facility.type_property]
      }),
    ),
  ]
    .filter(function (x) {
      return x !== undefined
    })
    .sort()
}

const centroid_from_feature = (feature) => {
  let lat_sum = 0
  let lon_sum = 0
  feature.geometry.coordinates[0].forEach((coordinate) => {
    lon_sum += coordinate[0]
    lat_sum += coordinate[1]
  })

  const coordinate_length = feature.geometry.coordinates[0].length
  return [lon_sum / coordinate_length, lat_sum / coordinate_length]
}

export {
  mapbox_to_geojson,
  get_number_geojson_properties,
  spatial_merge,
  feature_from_id,
  unique_fac_types,
  centroid_from_feature,
  capacity_from_details,
}
